<!-- Body Content -->
<div
  class="pt-2 md:pt-3 md:px-4 px-2 pb-8"
  data-testid="milestone-configurations-container"
>
  <div class="flex justify-content-between">
    <h1
      class="text-base md:text-lg flex align-items-center mb-0 line-height-1"
      data-testid="page-title"
    >
      {{ 'MILESTONE.MILESTONE_CONFIGURATIONS' | translate }}
    </h1>

    <div class="ml-2 flex align-items-center justify-content-end">
      <div
        (click)="onCreateMilestone()"
        class="hidden md:inline-block"
        data-testid="create-milestone-link"
      >
        <p-button
          icon="fa fa-plus"
          [label]="'MILESTONE.CREATE_MILESTONE_CONFIGURATION' | translate"
          styleClass="surface-0 p-button-outlined text-sm"
          aria-label="create-milestone-button"
        />
      </div>
      <div
        (click)="onCreateMilestone()"
        class="md:hidden"
        data-testid="create-milestone-link-mobile"
      >
        <p-button
          icon="fa fa-plus"
          styleClass="surface-0 p-button-outlined"
          aria-label="create-milestone-button-mobile"
        />
      </div>
    </div>
  </div>

  <div class="mt-1" data-testid="breadcrumb-container">
    <app-breadcrumb />
  </div>

  <div
    class="surface-0 shadow-2 border-round my-3"
    data-testid="milestones-table-container"
  >
    <div
      class="p-3 flex flex-wrap align-items-center justify-content-between border-bottom-1 border-300 gap-2"
    >
      <span class="text-900 font-normal text-sm mr-2" data-testid="total-count">
        {{ 'ADMIN.COMMON.TOTAL' | translate }} -
        <strong>{{ totalRecordLength().totalItems }}</strong>
        {{ 'MILESTONE.MILESTONE_CONFIGURATIONS' | translate }}
      </span>

      <div class="flex flex-wrap align-items-center gap-2" data-testid="milestone-config-filters">
        <!-- Search -->
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="fa fa-search" />
          <input type="text" pInputText
            [placeholder]="'common.PLACEHOLDER.SEARCH' | translate"
            class="text-sm w-full md:w-14rem"
            [ngModel]="searchText()"
            (input)="onSearch($any($event.target).value)"
            aria-label="search-milestone-configs-input"
            data-testid="search-milestone-configs-input" />
        </p-iconfield>

        <!-- Status Filter -->
        <p-select
          [options]="statusFilters"
          [(ngModel)]="selectedStatusFilter"
          optionLabel="name"
          optionValue="value"
          styleClass="text-sm w-full md:w-11rem"
          (onChange)="onStatusFilterChange($event.value)"
          aria-label="status-filter-dropdown"
          data-testid="status-filter-dropdown">
          <ng-template pTemplate="selectedItem" let-selected>
            <div class="text-sm">{{ selected?.name | translate }}</div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="text-sm">{{ item.name | translate }}</div>
          </ng-template>
        </p-select>

        @if (showAuditLogsFeature()) {
          <div class="hidden md:inline-block">
            <p-button (click)="showAuditTrail()" [label]="'Show Logs'" icon="fa fa-history" styleClass="text-sm p-button-text white-space-nowrap" aria-label="show-logs-button" />
          </div>
          <div class="md:hidden">
            <p-button (click)="showAuditTrail()" icon="fa fa-history" styleClass="p-button-outlined" aria-label="show-logs-button-mobile" />
          </div>
        }
      </div>
    </div>
    <app-data-grid
      [hidden]="loading()"
      [columnData]="tableData$"
      [loading]="loading()"
      [columns]="columns$"
      [totalRecords]="totalRecordLength$"
      [paginator]="true"
      [EmptyState]="emptyStateComponent$"
      [selectable]="selectAllData$"
      [resizableColumns]="true"
      [columnResizeMode]="'expand'"
      (loadNextData)="onPageChange($event)"
      (onAction)="onActionEvent($event)"
      data-testid="milestones-grid"
      [gridName]="'milestone-config-list'"
    />
  </div>
</div>
<!-- Body Content -->

@if (showAuditTrailSidebar() && showAuditLogsFeature()) {
  <p-drawer
    [visible]="showAuditTrailSidebar()"
    position="right"
    [modal]="true"
    [appendTo]="'body'"
    [autoZIndex]="true"
    [blockScroll]="true"
    [showCloseIcon]="false"
    styleClass="w-full md:w-30rem"
    (onHide)="hideAuditTrail()"
    aria-label="audit-trail-sidebar"
    header="Activity Log"
    data-testid="audit-trail-sidebar">
    <ng-template pTemplate="content">
      <fitness-force-audit-trail-mini entityType="milestone_configurations"
        entityId=""
        [tenantId]="tenantId()"
        [tenantData]="[]"
        [maxEvents]="10"
        [showStats]="true"
        [showFilters]="true"
        [showPagination]="true"
        height="100vh"
        title="Milestone Configuration Activity Log"
        [showCloseButton]="true"
        (closeEvent)="hideAuditTrail()"
        data-testid="audit-trail-mini-component" />
    </ng-template>
  </p-drawer>
}
